import React, { Component } from "react";

import FilterDropDown from "./FilterDropDown";

export default class LeaveBalanceCalculationFilters extends Component {
  handleDesignation = (val) => {
    this.props.handleFilterValue("selectedDesignation", val);
  };

  handleDepartment = (val) => {
    this.props.handleFilterValue("selectedDepartment", val);
  };

  handleBranch = (val) => {
    this.props.handleFilterValue("selectedBranch", val);
  };

  handleRegion = (val) => {
    this.props.handleFilterValue("selectedRegion", val);
  };

  render() {
    return (
      <div
        style={{
          marginTop: 20,
          marginBottom: 35,
          alignItems: "end",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <FilterDropDown
          label="Designation"
          dropDownList={this.props.designations}
          handleSelect={this.handleDesignation}
        />
        <FilterDropDown
          label="Department"
          dropDownList={this.props.departments}
          handleSelect={this.handleDepartment}
        />
        <FilterDropDown
          label="Branch"
          dropDownList={this.props.branches}
          handleSelect={this.handleBranch}
        />
        <FilterDropDown
          label="Region"
          dropDownList={this.props.regions}
          handleSelect={this.handleRegion}
        />
      </div>
    );
  }
}
